import {cloneElement, Fragment, ReactElement} from "react";
import classNames from "classnames";

interface FormRowProps {
  className?: string;
  children: ReactElement | boolean | null | (ReactElement | boolean | null)[];
}

const isReactElement = (element: ReactElement | boolean | null): element is ReactElement =>
  !!element && Object.keys(element).includes("props");

export const FormRow = ({className, children}: FormRowProps) => {
  const addPadding = (element: ReactElement | boolean | null) => {
    if (!isReactElement(element)) {
      return element;
    }
    return cloneElement(element, {
      ...element.props,
      className: classNames(element.props.className, "px-1 md:px-2")
    });
  };

  return (
    <div className={classNames(className,
      "flex flex-wrap -mx-1 md:-mx-2"
    )}>
      {
        Array.isArray(children)
          ? children.map((c, i) =>
            <Fragment key={i}>{c ? addPadding(c) : null}</Fragment>)
          : addPadding(children)
      }
    </div>
  );
};
